
import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';
import { VfbElement } from './Element';

const tagIdentifier = 'NOTIFY_PUBLIC_LINK';

@Component
export default class ElementTextExtra extends Vue {
  @Prop({ required: true })
  builderElement!: VfbElement;

  get notifyPublicLink(): boolean {
    let el = this.builderElement.tags;
    return Array.isArray(el) && el.includes(tagIdentifier);
  }

  set notifyPublicLink(value: boolean) {
    let el = this.builderElement.tags;

    if (typeof el === 'undefined' || !Array.isArray(el)) {
      this.$set(this.builderElement, 'tags', value ? [tagIdentifier] : []);
      return;
    }
    const index = el.indexOf(tagIdentifier);

    if (value && index === -1) {
      el.push(tagIdentifier);
    } else if (!value && index !== -1) {
      el.splice(index, 1);
    }
  }

  get uid(): string {
    return this._uid;
  }
}
